import { CONTROL_AUDIO } from '@/vuex/modules/presentation/remote-control-link.module'

export default {
  data() {
    return {
      unsubscribeAudioControlDelegate: null,
    }
  },
  computed: {

  },
  mounted() {
    this.subscribeAudioControl()
  },
  destroyed() {
    this.unsubscribeAudioControl()
  },
  methods: {
    subscribeAudioControl() {
      this.unsubscribeAudioControlDelegate = this.$store.subscribeAction(this.audioControlSubscriber)
    },

    unsubscribeAudioControl() {
      if (this.unsubscribeAudioControlDelegate) {
        this.unsubscribeAudioControlDelegate()
      }
    },
    audioControlSubscriber(action) {
      if (action.type !== CONTROL_AUDIO) return
      const { value, source } = action.payload
      if (!value || !source) return
      this.audioControlHandler(value)
    },

    audioControlHandler(value) {
      const { isPlaying, isMuted, time } = value
      if (typeof isPlaying === 'boolean') {
        this.togglePlay(isPlaying)
      }
      if (typeof isMuted === 'boolean') {
        this.toggleMute(isMuted)
      }
      if (typeof time === 'number') {
        this.seek(time)
      }
    },

    togglePlay(isPlaying) {
      throw new Error('togglePlay must be implemented', isPlaying)
    },

    toggleMute(isMuted) {
      const audio = this.getAudioSource()
      if (!audio) return
      audio.muted = isMuted
    },

    seek(time) {
      const audio = this.getAudioSource()
      if (!audio) return
      audio.currentTime = time
    },

    getAudioSource() {
      throw new Error('getAudioSource must be implemented')
    },
  },
}
